import type EnType from '../en-US/user';

export default {
  'user.login.password.required': 'Por favor, insira sua senha.',
  'user.login.password.required.placeholder': 'Digite a senha',
  'user.loginOrRegister.email': 'E-mail',
  'user.loginOrRegister.captcha.placeholder': 'Cole o código de verificação',
  'user.loginOrRegister.captcha.sendEmail': 'Enviar Código',
  'user.loginOrRegister.rule.required.captcha': 'Por favor, insira o código de verificação',
  'user.loginOrRegister.rule.required.mail': 'Por favor, insira o e-mail',
  'user.loginOrRegister.rule.pattern.mail': 'Por favor, insira o formato de e-mail correto',
  'user.login.password.error': 'Erro de senha, por favor tente novamente!',
  'user.login.password.tooManyErrors':
    'Você inseriu muitos erros de senha, por favor tente novamente mais tarde.',
  'user.request.message.rateLimit':
    'Solicitando com muita frequência, acesso restrito, tente novamente mais tarde',
  'user.login.message.invalidCaptcha': 'O código de verificação é inválido',
  'user.login.message.invalidCaptcha.tip':
    'O código de verificação está incorreto, por favor tente novamente',
} satisfies typeof EnType;
